export const findEqualOrGreaterNumberFromArray = (array, number) =>
  array.sort((a, b) => (a > b ? 1 : -1)).find((element) => element >= number);
